import Button from "../../components/Button";
import Leiste from "../../components/Leiste";

/**
 * Spotify-Geraet weg, waehrend das Spiel laeuft. Ein Tipp holt es zurueck,
 * ohne durch Menues zu suchen. Ist das Geraet ganz aus der Liste
 * verschwunden, hilft nur das Oeffnen der Spotify-App — dann ist DAS der
 * Hauptknopf.
 */
export default function GeraeteBanner({ geraetVerschwunden, spotifyStatus, sucht, onSpotifyOeffnen, onWecken, onHierAbspielen }) {
  if (geraetVerschwunden) {
    // Mit Browser-Player: "Hier abspielen" ist der stabile Weg (die
    // Spotify-App friert iOS bei jeder Pause ein) und deshalb der Hauptknopf.
    if (onHierAbspielen) {
      return (
        <Leiste icon="handy" titel="Spotify abgemeldet" text="Am stabilsten spielt die Musik direkt hier im Quiz.">
          <Button variant="haupt" disabled={sucht} onClick={onHierAbspielen}>
            {sucht ? "Verbinde…" : "Hier abspielen"}
          </Button>
          <a className="knopf neben" href="spotify:" onClick={onSpotifyOeffnen}>
            Spotify öffnen
          </a>
        </Leiste>
      );
    }
    return (
      <Leiste icon="handy" titel="Spotify abgemeldet" text="App kurz öffnen, dann neu suchen.">
        <a className="knopf neben" href="spotify:" onClick={onSpotifyOeffnen}>
          Spotify öffnen
        </a>
        <Button variant="text" disabled={sucht} onClick={onWecken}>
          {sucht ? "…" : "Neu suchen"}
        </Button>
      </Leiste>
    );
  }
  const keinGeraet = spotifyStatus === "NO_DEVICE";
  return (
    <Leiste
      icon={keinGeraet ? "lautsprecher" : "wlan-aus"}
      titel={keinGeraet ? "Spotify spielt nirgends" : "Keine Verbindung zu Spotify"}
      text="Tippen holt das Gerät zurück."
    >
      <Button variant="haupt" disabled={sucht} onClick={onWecken}>
        {sucht ? "Suche…" : "Aufwecken"}
      </Button>
    </Leiste>
  );
}
